import { Crown, Lock } from "lucide-react";

export const LIME = "#c1ff72";
export const TIER_LABEL = { free: "Kostenlos", premium: "Premium", premium_plus: "Premium Plus" };
export const DIFF_LABEL = { anfaenger: "Anfänger", fortgeschritten: "Fortgeschritten", leistung: "Leistung" };

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs uppercase tracking-[0.2em] font-semibold text-[#c1ff72] ${className}`}>{children}</p>
);

export const H1 = ({ children, className = "", ...rest }) => (
  <h1 {...rest} className={`font-['Bebas_Neue'] uppercase tracking-tight leading-[0.9] text-white text-5xl sm:text-6xl lg:text-7xl ${className}`}>{children}</h1>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-['Bebas_Neue'] uppercase tracking-tight leading-none text-white text-3xl sm:text-4xl ${className}`}>{children}</h2>
);

export function TierBadge({ tier, testId }) {
  if (!tier || tier === "free") return null;
  const plus = tier === "premium_plus";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest ${plus ? "bg-[#FFD700] text-black" : "bg-[#c1ff72] text-black"}`}>
      <Crown className="w-3 h-3" />{plus ? "Plus" : "Pro"}
    </span>
  );
}

export const LockBadge = () => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest bg-black/70 text-white border border-white/20 backdrop-blur"><Lock className="w-3 h-3" />Gesperrt</span>
);

export function ChipSelect({ options, value, onChange, multi = false, testPrefix, max }) {
  const toggle = (id) => {
    if (!multi) return onChange(id);
    const has = value.includes(id);
    if (!has && max && value.length >= max) return undefined;
    return onChange(has ? value.filter((v) => v !== id) : [...value, id]);
  };
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => {
        const on = multi ? value.includes(o.id) : value === o.id;
        return (
          <button key={o.id} type="button" onClick={() => toggle(o.id)} data-testid={`${testPrefix}-${o.id}`}
            className={`px-4 py-2.5 text-sm border transition-colors duration-150 active:scale-95 ${on ? "bg-[#c1ff72] text-black border-[#c1ff72] font-semibold" : "bg-transparent text-white border-white/15 hover:border-white/40"}`}>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export const Spinner = () => <div className="w-6 h-6 border-2 border-white/20 border-t-[#c1ff72] rounded-full animate-spin" data-testid="loading-spinner" />;

export const PageLoader = () => <div className="min-h-[50vh] flex items-center justify-center"><Spinner /></div>;
